import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.copyConfig && _vm.copyConfig.properties ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "1000"
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.applyBtnText')) + "\n    "), _c('p', {
          staticClass: "card-description mt-4"
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.description')) + "\n    ")])];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.applyBtnText'),
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.applyStateConfig
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fas fa-paste")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.applyBtnText')) + "\n    ")], 1)];
      },
      proxy: true
    }], null, false, 1173216726)
  }, [_c(VForm, {
    ref: "form"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t(`NiotaClassic.Applications.form.${!_vm.areAllItemsSelected ? '' : 'un'}selectAll`),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.toggleAllItems
    },
    model: {
      value: _vm.areAllItemsSelected,
      callback: function ($$v) {
        _vm.areAllItemsSelected = $$v;
      },
      expression: "areAllItemsSelected"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.detailsHeadline')))])])], 1), _c(VRow, [_c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.title,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "title", $$v);
      },
      expression: "valuesToCopy.title"
    }
  })], 1), _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.key'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.key,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "key", $$v);
      },
      expression: "valuesToCopy.key"
    }
  })], 1), _vm.copyConfig.properties.unit ? _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.unit,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "unit", $$v);
      },
      expression: "valuesToCopy.unit"
    }
  })], 1) : _vm._e(), _vm.copyConfig.properties.faIcon ? _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.icon'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.faIcon,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "faIcon", $$v);
      },
      expression: "valuesToCopy.faIcon"
    }
  })], 1) : _vm._e(), _vm.copyConfig.properties.linkGeoCoordinate !== undefined ? _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.geoCoordinateConfig'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.linkGeoCoordinate,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "linkGeoCoordinate", $$v);
      },
      expression: "valuesToCopy.linkGeoCoordinate"
    }
  })], 1) : _vm._e(), _vm.copyConfig.properties.geoCoordinateKey ? _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.geoCoordinateField'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.geoCoordinateKey,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "geoCoordinateKey", $$v);
      },
      expression: "valuesToCopy.geoCoordinateKey"
    }
  })], 1) : _vm._e()], 1), _c(VRow, {
    attrs: {
      "justify": "space-between"
    }
  }, [_c(VCol, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.stateConfig')))])])], 1), _c(VRow, [_c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.sourceType'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.bindingType,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "bindingType", $$v);
      },
      expression: "valuesToCopy.bindingType"
    }
  })], 1), _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.valueType'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.valueType,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "valueType", $$v);
      },
      expression: "valuesToCopy.valueType"
    }
  })], 1), _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.panelTitle'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.visualization,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "visualization", $$v);
      },
      expression: "valuesToCopy.visualization"
    }
  })], 1), _vm.copyConfig.properties.binding.transformer && _vm.copyConfig.properties.binding.transformer.script ? _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformer'),
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refresh
    },
    model: {
      value: _vm.valuesToCopy.transformer,
      callback: function ($$v) {
        _vm.$set(_vm.valuesToCopy, "transformer", $$v);
      },
      expression: "valuesToCopy.transformer"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };